import {ChacrasGeoActions, ChacrasGeoActionTypes} from './chacras-geo.actions';
import {chacrasGeoAdapter, ChacrasGeoState, initialState} from './chacras-geo.state';

export function chacrasGeoReducer(state = initialState, action: ChacrasGeoActions): ChacrasGeoState {
  switch (action.type) {
    // load
    case ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_REQUEST: {
      return {
        ...state,
        isLoading: true,
        error: null
      };
    }
    case ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_SUCCESS: {
      return chacrasGeoAdapter.addMany(action.payload.items, {
        ...state,
        isLoading: false,
        error: null
      });
    }
    case ChacrasGeoActionTypes.CHACRAS_GEO_LOAD_FAILURE: {
      return {
        ...state,
        isLoading: false,
        error: action.payload.error
      };
    }
    // default
    default: {
      return state;
    }
  }
}
